import { action, computed, makeObservable, observable } from 'mobx';

export class ErrorStore {
  constructor() {
    makeObservable(this);
  }

  @observable private _validationErrors: Set<string> = new Set<string>();

  @computed get validationErrors(): string[] {
    return Array.from(this._validationErrors.values());
  }

  @computed get hasValidationErrors(): boolean {
    return this._validationErrors.size > 0;
  }

  @action reportValidationError(errorMessage: string, autoHideDurationMs?: number) {
    this._validationErrors.add(errorMessage);

    autoHideDurationMs && setTimeout(() => {
      this._validationErrors.delete(errorMessage);
    }, autoHideDurationMs);
  }

  @action 
  reportValidationErrors(errorMessages: string[]): void {
    errorMessages.forEach((errorMessage) => {
      this._validationErrors.add(errorMessage);
    });
  }

  @action 
  clearValidationErrors(): void {
    this._validationErrors.clear();
  }
}
